// Utilitarios de seguranca do nucleo.

/**
 * Sanitiza um destino de redirecionamento (parametro `next`) contra open
 * redirect. Aceita SOMENTE caminhos internos absolutos. Rejeita URLs externas,
 * protocol-relative (//host), backslash (/\host) e vazios -> cai no padrao.
 * Achado de seguranca #9 (14/07/2026).
 */
export function sanitizarNext(next: string | null | undefined, padrao = '/painel'): string {
  if (!next) return padrao;
  if (!next.startsWith('/')) return padrao; // precisa ser caminho interno
  if (next.startsWith('//')) return padrao; // protocol-relative -> externo
  if (next.startsWith('/\\')) return padrao; // backslash trick
  return next;
}
